import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const getOverviewStatisticsLite = params => {
  return httpClient
    .get('/overview/statisticsLite', { params, timeout: 180000 })
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const getOverviewReservationsLite = (type, params) => {
  return httpClient
    .get(`/overview/${type}Lite`, { params, timeout: 180000 })
    .then(response => response.data)
    .catch(apiErrorHandler);
};
